import "./App.css";
import AppRoutes from "./Routes/AppRoutes";
import "../src/Assets/css/common.css";
import "./Assets/css/bootstrap.min.css";
import "./Assets/css/common.css";
import "./Assets/css/dashboard.css";
import "./Assets/css/user_dashboard.css";
import "./Assets/css/user_fund.css";
import "./Assets/css/login.css";
import "./Assets/css/registration_page.css";
import "./Assets/css/client_dashboard.css";
import "./Assets/css/forgot_password.css";
import "./Assets/css/loader.css";
import "./Assets/css/user_login.css";
import "./Assets/css/create_fund.css";
import "./Assets/css/dashboard_component.css";
import { Toaster } from "react-hot-toast";
import Provider from "./Store/StoreProvider";
import { useEffect, useRef } from "react";
import { toast } from "react-hot-toast";
import { initializeAnalytics, trackPageView } from "./Analytics/analytics";
import AppContext from "./Store/AppContext";
import { useContext } from "react";
import { trackError } from "./Analytics/analytics";
import { ModuleRegistry } from 'ag-grid-community';
import { ClientSideRowModelModule } from 'ag-grid-community';
import { LicenseManager } from "ag-grid-enterprise";
import { logout } from "./Utils";

ModuleRegistry.registerModules([ClientSideRowModelModule]);

LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-076341}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Reg_X_Innovations}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{reg-x}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{reg-x}_need_to_be_licensed___{reg-x}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{4_February_2026}____[v3]_[0102]_MTc3MDE2MzIwMDAwMA==5750d9a51f168fe3e237b2b0864eb237");
function App() {
  const timeoutRef = useRef(null);
  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      logout();
      // console.log('1');
      window.location.href = '/login';
      // console.log('2');
    }, 50 * 60 * 1000); // 50 minutes
  };

  // console.log('timeout ', timeoutRef.current);

  useEffect(() => {
    // Listen to mouse movement
    const handleActivity = () => {
      resetTimeout();
    };

    window.addEventListener('mousemove', handleActivity);
    // Set initial timeout
    resetTimeout();

    return () => {
      window.removeEventListener('mousemove', handleActivity);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <Provider>
      <div className="App">
        <AppRoutes />
        <Toaster />
      </div>
    </Provider>
  );
}

export default App;

